export const NotesIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='16' height='16' rx='2' fill='white' />
    <path d='M4.5 4H11.5V6H4.5V4Z' fill='#FBBF24' />
    <path d='M4.5 7H11.5V9H4.5V7Z' fill='#FBBF24' />
    <path d='M4.5 10H9.16667V12H4.5V10Z' fill='#FBBF24' />
  </svg>
);
